var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-confirmation-modal',{ref:"runStatusUpdateModal",attrs:{"title":_vm.title,"message":_vm.message,"ok-button-name":_vm.$t('yes'),"ok-button-prevent-hiding":"","ok-button-spinners-enabled":"","cancel-button-name":_vm.$t('no')},on:{"ok":function($event){return _vm.$emit('ok')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }